import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, forwardRef, Input } from '@angular/core';
import {
  ControlValueAccessor,
  FormsModule,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule
} from '@angular/forms';
import { EINVOICE_BILLING_FREQ } from '@core';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { ViewItemComponent } from 'src/app/shared/components/view-item/view-item.component';

@Component({
  selector: 'app-einvoice-billing-freq-select',
  templateUrl: './einvoice-billing-freq-select.component.html',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    NzFormModule,
    NzSelectModule,
    ReactiveFormsModule,
    ViewItemComponent
  ],
  styles: [],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EInvoiceBillingFreqSelectComponent),
      multi: true
    }
  ]
})
export class EInvoiceBillingFreqSelectComponent
  implements ControlValueAccessor
{
  statusLabel: { [key: string]: string } = {};
  options = [...EINVOICE_BILLING_FREQ];

  @Input() value: string = '';
  @Input() disabled = false;
  @Input() borderless = false;

  get readonly() {
    if (this.disabled) {
      return true;
    }
    return false;
  }

  get displayText() {
    const item = this.options.find(x => x.value === this.value);
    if (item) return `${item.value} - ${item.label}`;
    return '';
  }

  onChange: any = () => {};
  onTouched: any = () => {};
  constructor(private cdr: ChangeDetectorRef) {}

  writeValue(value: string): void {
    this.value = value;
    this.onChange(value);
    this.cdr.markForCheck();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onModelChange(val: any) {
    this.value = val;
    this.onChange(val);
    this.cdr.markForCheck();
  }

  onKeydown(event: any) {
    if (event.ctrlKey || event.metaKey) return;

    const key = `${event.key}`;
    if (key.length !== 1) return;

    const allow =
      (key >= '0' && key <= '9') ||
      (key >= 'A' && key <= 'Z') ||
      (key >= 'a' && key <= 'z') ||
      key === '-' ||
      key === '/';
    if (!allow) {
      event.preventDefault();
    }
  }
}
